<div style="margin-bottom: 10px;font-weight:700">Builds for definition "{{data.title}}"</div>
<mat-dialog-content>
  <mat-tab-group>
    <mat-tab *ngFor="let group of data.groupedBuilds" label="{{group.displayName}} ({{group.builds.length}})">
      <table>
        <thead>
          <td>Build Number</td>
          <td>Definition</td>
          <td>Start</td>
          <td>Finish</td>
          <td>Duration</td>
          <td>Status</td>
        </thead>
        <tr *ngFor="let build of group.builds">
          <td><a target="_blank" href={{build.webLink}}>{{build.buildNumber}}</a></td>
          <td>{{build.definition.displayName}}</td>
          <td>{{build.startTime | date:'M/d/yy hh:mm a'}}</td>
          <td>{{build.finishTime | date:'hh:mm a'}}</td>
          <td>{{build.duration}}</td>
          <td>{{shortStatus(build)}}</td>
        </tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
